import React from 'react'
import { Link } from "react-router-dom"

class Widget extends React.Component {
  close() {
    this.props.close()
  }
  render() {
    // return (
    //   <div className="refund__bg">
    //     <div className="refund__result">
    //       <p className="refund__result__heading">Система недоступна!</p>
    //       <div className="refund__close" onClick={() => {this.close()}}></div>
    //       <img src="/img/il_hand.png" className="refund__result__ill"/>
    //       <p className="refund__result__description">
    //       Вибачте, система онлайн продажу квитків тимчасово недоступна. Ми працюємо над вирішенням цієї проблеми.<br /><br /> Ви як і раніше можете придбати квитки в касі кінотеатру
    //       </p>
    //     </div>
    //   </div>
    // )
    if (window.innerWidth <= 1024) {
      window.location = "//gate.zhovten-kino.kyiv.ua/seats.html?CinemaId=" + this.props.cinemaId + "&SessionId=" + this.props.sessionId + "&back_url=" + window.location.href
      return null
    } else {
      return (
        <div className="widget">
          <div className="header">
            <div className="back" onClick={() => { this.close() }}></div>
            <p className="heading"><Link to={"/movie/" + this.props.filmId} className="tomvi" onClick={() => { this.close() }}>{this.props.filmName},</Link> <span className="hall">{this.props.hallName}</span></p>
            <div className="close" onClick={() => { this.close() }}></div>
          </div>
          <iframe title="widget" src={"//gate.zhovten-kino.kyiv.ua/seats.html?CinemaId=" + this.props.cinemaId + "&SessionId=" + this.props.sessionId + "&back_url=" + window.location.href} frameBorder="0"></iframe>
        </div>
      )
    }
  }
}

export default Widget


// WEBPACK FOOTER //
// ./src/components/snippets/Widget.jsx